// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verify-email-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #F3F4F6;
}

.verify-email-card {
  background-color: #FFFDFC;
  padding: 3rem;
  border-radius: 0.8rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 40rem;
  text-align: center;
}

.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
}

.logo {
  width: 12rem;
  height: auto;
}

.verify-email-card h1 {
  color: #2C3948;
  font-size: 2.4rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
}

.verify-email-content {
  margin: 2.5rem 0;
}

.verify-email-content p {
  color: #2C3948;
  font-size: 1.6rem;
  margin-bottom: 2rem;
}

.verify-email-content > button {
  display: block;
  margin: 0 auto;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

.error-message {
  background-color: #FEE2E2;
  color: #B91C1C;
  padding: 1rem;
  border-radius: 0.5rem;
  margin: 1rem 0;
}

.success-message {
  background-color: #DCFCE7;
  color: #166534;
  padding: 1rem;
  border-radius: 0.5rem;
  margin: 1rem 0;
}

.verify-email-footer {
  margin-top: 2rem;
  color: #6B7280;
  font-size: 1.4rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/VerifyEmail/VerifyEmail.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".verify-email-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #F3F4F6;\n}\n\n.verify-email-card {\n  background-color: #FFFDFC;\n  padding: 3rem;\n  border-radius: 0.8rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 40rem;\n  text-align: center;\n}\n\n.logo-container {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 2rem;\n}\n\n.logo {\n  width: 12rem;\n  height: auto;\n}\n\n.verify-email-card h1 {\n  color: #2C3948;\n  font-size: 2.4rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n}\n\n.verify-email-content {\n  margin: 2.5rem 0;\n}\n\n.verify-email-content p {\n  color: #2C3948;\n  font-size: 1.6rem;\n  margin-bottom: 2rem;\n}\n\n.verify-email-content > button {\n  display: block;\n  margin: 0 auto;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.error-message {\n  background-color: #FEE2E2;\n  color: #B91C1C;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  margin: 1rem 0;\n}\n\n.success-message {\n  background-color: #DCFCE7;\n  color: #166534;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  margin: 1rem 0;\n}\n\n.verify-email-footer {\n  margin-top: 2rem;\n  color: #6B7280;\n  font-size: 1.4rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
